import * as types from "./mutationTypes";
import { i18n } from "@/boot/i18n";

export default {
  [types.SET_PROFILE](state, profile) {
    state.profile = profile;
    // Set primary language from user
    i18n.locale = profile.primary_language;
    if (typeof window !== "undefined") {
      localStorage.setItem("t-profile", JSON.stringify(profile));
    }
  },
  [types.CLEAR_PROFILE](state) {
    state.profile = {};
  },
  [types.SET_FIELD](state, { field, value }) {
    state.profile[field] = value;
  },
  [types.SET_EDIT_FIELD](state, { field, value }) {
    state.profileEdit[field] = value;
  },
  [types.SET_PROFILE_EDIT](state, profile) {
    state.profileEdit = profile;
  },
  [types.CLEAR_PROFILE_EDIT](state) {
    state.profileEdit = {};
  }
};
